import { useEffect } from "react";

/**
 * Sets the document title and meta description for SEO.
 * Restores defaults on unmount.
 */
export default function useSEO({ title, description } = {}) {
  useEffect(() => {
    const defaultTitle = document.title;
    const descTag = document.querySelector('meta[name="description"]');
    const defaultDesc = descTag ? descTag.getAttribute("content") : "";
    const ogTitle = document.querySelector('meta[property="og:title"]');
    const ogDesc = document.querySelector('meta[property="og:description"]');

    if (title) {
      document.title = `${title} | Prime Trade L.L.C — FZ`;
      if (ogTitle) ogTitle.setAttribute("content", document.title);
    }
    if (description && descTag) {
      descTag.setAttribute("content", description);
      if (ogDesc) ogDesc.setAttribute("content", description);
    }

    return () => {
      document.title = defaultTitle;
      if (descTag) descTag.setAttribute("content", defaultDesc);
    };
  }, [title, description]);
}
